import React, { Component, ErrorInfo, ReactNode } from 'react';
import GenericError from '../generic-error/GenericError';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    const { hasError } = this.state;

    if (hasError) {
      return (
        <GenericError
          heading={'Something went wrong'}
          description={
            'Try reloading? If the problem persists please get in touch - support@skillspace.app'
          }
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
